<!-- Error -->
<div *ngIf="!accessible || error">
  <div class="alert alert-danger">
    {{ error }}
  </div>
</div>

<div *ngIf="!surveyQuestions && !error && accessible">
  <div class="alert alert-primary">
    Please wait whilst we load the survey...
  </div>
</div>

<!-- Survey -->
<div *ngIf="accessible && surveyForm">

  <!-- Session codes -->
  <div class="mb-3" *ngIf="survey.sessionStorage == true && sessionCodes">
    <p>
      The following {{ survey.codeTitle.toLowerCase() }} surveys have been completed in the current session. These will only be accessible whilst you remain on the website.
    </p>
    <div *ngFor="let code of sessionCodes; let i = index" [class]="code == caseCode.toLowerCase() ? 'btn btn-success mr-2 mt-2 cursor' : 'btn btn-secondary mr-2 mt-2 cursor'" (click)="caseCode !== code ? toggleCode(code, survey) : null">
      {{ survey.codeTitle }} {{ i + 1 }}
    </div>
    <hr>
    <div class="alert alert-success">
      <p>Unique Patient Reference: <strong>{{ caseCodeSplit[2] }}-{{ caseCodeSplit[3] }}</strong></p>
      <p><small>Please keep a local record of this patient reference number, to aid with any data queries.</small></p>
    </div>
  </div>

  <img *ngIf="survey.surveyLogoPath" src="{{ survey.surveyLogoPath }}" alt="Logo" class="logo">
  <h2>Welcome to the {{ survey.surveyName }}</h2>

  <!-- Qualification Question (NHSE&I LD)-->
  <div class="row" *ngIf="survey.qualificationQuestion == true">
    <div class="col-12 mb-4">
      <div class="mb-3">
        <label for="qualification" class="font-weight-bold">Which area of the Trust do you work in?</label>
        <p class="text-secondary">You will need to select your area of work before continuing. When you select an area, the remaining questions will appear.</p>
      </div>
      <button [class]="qualificationSelection === communityListId ? 'btn btn-primary mr-2' : 'btn btn-outline-primary mr-2'" (click)="changeQualification(communityListId)" [disabled]="qualificationSelection">Community</button>
      <button [class]="qualificationSelection === hospitalListId ? 'btn btn-primary mr-2' : 'btn btn-outline-primary mr-2'" (click)="changeQualification(hospitalListId)" [disabled]="qualificationSelection">Hospital</button>
    </div>
  </div>

  <form [formGroup]="surveyForm" *ngIf="showSurvey">
    <div *ngFor="let q of surveyQuestions" class="question">
      <div [ngSwitch]="q.type" *ngIf="!q.hide">

        <!-- Narrative -->
        <div class="row" *ngSwitchCase="'narrative'">
          <div class="col-12 narrative">
            <h4 *ngIf="q.format === 'H'" [id]="q.id" [innerHTML]="q.label"></h4>
            <p *ngIf="!q.format" [id]="q.id" [innerHTML]="q.label"></p>
          </div>
        </div>

        <!-- List Item -->
        <div class="row" *ngSwitchCase="'list'">

          <!-- Standard List -->
          <ng-container *ngIf="q.format !== 'L'">
            <div [class]="q.format === 'S' ? 'col-12 sub-question' : 'col-12'">
              <div *ngIf="q.incomplete" class="unanswered"><br><i class="fas fa-exclamation-circle"></i> This question is unanswered</div>
              <label [for]="q.id" class="question-text">
                <span *ngIf="q.prefix" class="text-secondary prefix">{{ q.prefix }}</span>
                <span [innerHTML]="q.label"></span>
                <i class="fas fa-question-circle ml-2 text-muted cursor" *ngIf="q.help" (click)="toggleHelp(q)"></i>
              </label>
              <div class="text-muted mb-2" *ngIf="q.showHelp">{{ q.help }}</div>
              <div *ngFor="let o of q.options" class="form-check">
                <input class="form-check-input" type="radio" [id]="o.optionId + '-' + o.displaySequence" formControlName="{{ q.id }}" [value]="o.optionId">
                <label class="form-check-label" [for]="o.optionId + '-' + o.displaySequence">
                  {{ o.optionName }}
                </label>
              </div>
            </div>
          </ng-container>

          <!-- Likert Scale -->
          <ng-container *ngIf="q.format === 'L'">
            <div class="col-12">
              <div *ngIf="q.incomplete" class="unanswered"><br><i class="fas fa-exclamation-circle"></i> This question is unanswered</div>
              <label [for]="q.id" class="question-text">
                <span *ngIf="q.prefix" class="text-secondary prefix">{{ q.prefix }}</span>
                <span [innerHTML]="q.label"></span>
                <i class="fas fa-question-circle ml-2 text-muted cursor" *ngIf="q.help" (click)="toggleHelp(q)"></i>
              </label>
              <div class="text-muted mb-2" *ngIf="q.showHelp">{{ q.help }}</div>
              <div class="row justify-content-between">
                <div *ngFor="let o of q.options" class="col-md-2 col-12">
                  <div class="form-check likert">
                    <input class="form-check-input" type="radio" [id]="o.optionId + '-' + o.displaySequence" formControlName="{{ q.id }}" [value]="o.optionId">
                    <br class="likert-break">
                    <label class="form-check-label" [for]="o.optionId + '-' + o.displaySequence">
                      {{ o.optionName }}
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>

        </div>

        <!-- Checkbox Item -->
        <div class="row" *ngSwitchCase="'yn'">
          <div class="col-12">
            <div class="form-check">
              <input type="checkbox" class="form-check-input" [id]="q.id" formControlName="{{ q.id }}">
              <label class="form-check-label" [for]="q.id">{{ q.label }}</label>
              <i class="fas fa-question-circle ml-2 text-muted cursor" *ngIf="q.help" (click)="toggleHelp(q)"></i>
              <div class="text-muted mb-2" *ngIf="q.showHelp">{{ q.help }}</div>
            </div>
          </div>
        </div>

        <!-- Number -->
        <div class="row" *ngSwitchCase="'number'">
          <div class="col-12">
            <div class="form-group">
              <div *ngIf="q.incomplete" class="unanswered"><br><i class="fas fa-exclamation-circle"></i> This question is unanswered</div>
              <label [for]="q.id" class="question-text">
                <span *ngIf="q.prefix" class="text-secondary prefix">{{ q.prefix }}</span>
                <span [innerHTML]="q.label"></span>
                <i class="fas fa-question-circle ml-2 text-muted cursor" *ngIf="q.help" (click)="toggleHelp(q)"></i>
              </label>
              <div class="text-muted mb-2" *ngIf="q.showHelp">{{ q.help }}</div>
              <input type="number" class="form-control col-md-4" [id]="q.id" formControlName="{{ q.id }}">
            </div>
          </div>
        </div>

        <!-- Date -->
        <div class="row" *ngSwitchCase="'date'">
          <div class="col-12">
            <div class="form-group">
              <div *ngIf="q.incomplete" class="unanswered"><br><i class="fas fa-exclamation-circle"></i> This question is unanswered</div>
              <label [for]="q.id" class="question-text">
                <span *ngIf="q.prefix" class="text-secondary prefix">{{ q.prefix }}</span>
                <span [innerHTML]="q.label"></span>
                <i class="fas fa-question-circle ml-2 text-muted cursor" *ngIf="q.help" (click)="toggleHelp(q)"></i>
              </label>
              <div class="text-muted mb-2" *ngIf="q.showHelp">{{ q.help }}</div>
              <input type="date" class="form-control" [id]="q.id" formControlName="{{ q.id }}" datetime="dd/mm/yyyy">
            </div>
          </div>
        </div>

        <!-- Text -->
        <div class="row" *ngSwitchCase="'string'">
          <div class="col-12">
            <div class="form-group">
              <div *ngIf="q.incomplete" class="unanswered"><br><i class="fas fa-exclamation-circle"></i> This question is unanswered</div>
              <label [for]="q.id" class="question-text">
                <span *ngIf="q.prefix" class="text-secondary prefix">{{ q.prefix }}</span>
                <span [innerHTML]="q.label"></span>
                <i class="fas fa-question-circle ml-2 text-muted cursor" *ngIf="q.help" (click)="toggleHelp(q)"></i>
              </label>
              <div class="text-muted mb-2" *ngIf="q.showHelp">{{ q.help }}</div>
              <textarea type="textarea" class="form-control" [id]="q.id" formControlName="{{ q.id }}"></textarea>
            </div>
          </div>
        </div>

      </div> <!-- end switch -->
    </div> <!-- end surveyQuestions -->

    <!-- Check for incomplete -->
    <div class="text-danger" *ngIf="incompleteResponses && survey.checkIncomplete">
      <p (click)="incompleteCheck(surveyForm, true)" class="cursor">
        <i class="fas fa-exclamation-circle"></i>&nbsp;<strong>There are incomplete questions above.</strong> Click here to highlight the incomplete questions above.
      </p>
    </div>

    <div class="actions" *ngIf="survey.editable">
      <p class="mt-2">
        If you would like to return to this survey later, please bookmark this page (or save the URL below), then click 'Save for later'.
        <br><strong>https://surveys.nhsbenchmarking.nhs.uk{{ router.url }}</strong>
      </p>
      <button class="btn btn-outline-success" (click)="submit('remain')" [disabled]="!surveyForm.dirty">
        {{ saving ? 'Saving your responses...' : 'Save for later' }}
      </button>
      <p *ngIf="success && !surveyForm.dirty" class="text-success mt-2">
        {{ success }}
      </p>
    </div>

    <div class="actions">
      <p>
        {{ survey.submitInstructions }} <span *ngIf="survey.editable">You will not be able to return to the survey once submitted.</span>
      </p>
      <button class="btn btn-lg btn-success" (click)="submit('complete')" [disabled]="!surveyForm.dirty || (incompleteResponses && survey.checkIncomplete)">
        <span *ngIf="!survey.sessionStorage">{{ saving ? survey.submitButtonLoading : survey.submitButton }}</span>
        <span *ngIf="survey.sessionStorage">{{ saving ? survey.submitButtonLoading : survey.saveAndSubmitButton }}</span>
      </button>
      <button *ngIf="survey.sessionStorage" class="btn btn-outline-success ml-2" (click)="submit('add')" [disabled]="!surveyForm.dirty">
        {{ saving ? survey.saveButtonLoading : survey.saveStartNew + survey.codeTitle.toLowerCase() }}
      </button>
    </div>

  </form>

</div>
